import React from 'react'
import { PropTypes } from 'prop-types'

import {
  Container, Input, Button, Alert
} from '@sainsburys-tech/fable'
import api from '../../utils/api'
import EmailConfirmationModal from '../Email/EmailConfirmationModal'
import LoadingOverlay from '../LoadingOverlay'

class UsernamePassword extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      password: '',
      confirmPassword: '',
      passwordFieldBlured: false,
      confirmPasswordBlured: false,
      isRememberMeChecked: false,
      error: null,
      isModalOpen: false,
      loading: false
    }
  }

  componentDidMount() {
    const {
      setHeader, contractor, rememberMe, setSignOutHeader
    } = this.props
    setHeader()
    setSignOutHeader(false)

    if (!contractor) {
      window.location.href = '/register'
    }
    this.setState({ isRememberMeChecked: rememberMe })
  }

  checkAllFieldsValid = () => {
    const regex = /^(.{0,11}|[^0-9]*|[^A-Z]*|[a-zA-Z0-9]*)$/ // must be min length of 12, 1 uppercase, 1 number and 1 symbol
    const {
      password, confirmPassword
    } = this.state
    const { contractor } = this.props
    if (password === ''
      || confirmPassword === ''
      || (password !== confirmPassword)
      || (regex.test(password)
        || contractor.employerId === 0)
    ) {
      return false
    }
    return true
  }

  handleTextChange = (value, key) => {
    this.setState({ [key]: value })
  }

  setPasswordBlur = () => {
    this.setState({ passwordFieldBlured: true })
  }

  setConfirmPasswordBlur = () => {
    this.setState({ confirmPasswordBlured: true })
  }

  getPasswordStatus = () => {
    const { password, passwordFieldBlured } = this.state
    const regex = /^(.{0,11}|[^0-9]*|[^A-Z]*|[a-zA-Z0-9]*)$/ // must be min length of 12, 1 uppercase, 1 number and 1 symbol

    if (!passwordFieldBlured) return undefined
    if (!password) return undefined

    if (regex.test(password)) {
      return {
        type: 'error',
        message: 'Password must be at least 12 characters and consist of a number, uppercase letter and special character'
      }
    }
    return undefined
  }

  getConfirmPasswordStatus = () => {
    const { password, confirmPassword, confirmPasswordBlured } = this.state
    if (!confirmPasswordBlured) return undefined
    if (!confirmPassword) return undefined

    if (confirmPassword !== password) {
      return { type: 'error', message: 'Your passwords don\'t match' }
    }
    return undefined
  }

  getEmployerErrorMessage = () => {
    const { contractor } = this.props
    if (!contractor) return null
    if (contractor.employerId === 0) {
      return 'Please select an employer from the dropdown on the previous page'
    }
    return null
  }

  getSubmitErrorMessage = () => {
    const { error } = this.state
    if (!error) return null
    if (typeof error === 'string') return error
    if (error && typeof error.message === 'string') return error.message
    return 'Unable to register'
  }

  handleRemeberMeChange = () => {
    const { isRememberMeChecked } = this.state
    this.setState({ isRememberMeChecked: !isRememberMeChecked })

    const { setRememberMe } = this.props
    setRememberMe(!isRememberMeChecked)
  }

  openEmailConfirmationModal = () => {
    const { isModalOpen } = this.state
    const { history, contractor } = this.props
    return (
      <EmailConfirmationModal isModalOpen={isModalOpen} history={history} email={contractor.email} />
    )
  }

  handleSubmit = () => {
    const { contractor } = this.props
    const {
      forename,
      surname,
      email,
      telephoneNumber,
      vehicleRegistration,
      employerId,
      jobRoleId,
      acceptedTCs
    } = contractor

    const { password } = this.state
    const details = {
      forename,
      surname,
      telephoneNumber,
      carRegistration: vehicleRegistration,
      employerId,
      jobRoleId,
      username: email,
      email,
      password,
      acceptedTCs
    }
    this.setState({ loading: true })
    api.registerContractor(details)
      .then((res) => {
        if (res.status === 200) {
          this.setState({ isModalOpen: true, loading: false })
        } else {
          this.setState({ isModalOpen: false, loading: false, error: 'Unable to register' })
        }
      })
      .catch(error => this.setState({ error, loading: false }))
  }

  render() {
    const {
      password,
      confirmPassword,
      loading
    } = this.state

    const { contractor } = this.props

    if (!contractor) {
      return null
    }

    const employerErrorMessage = this.getEmployerErrorMessage()
    const submitErrorMessage = this.getSubmitErrorMessage()

    return (
      <div className="dsib-usernamePassword">
        {this.openEmailConfirmationModal()}
        <Container size="xl">
          <div className="dsib-usernamePassword__inner">
            <h2 className="dsib-usernamePassword__title">Almost there...</h2>

            <div className="dsib-usernamePassword__username">
              <div className="dsib-usernamePassword__usernameLabel">Your username:</div>
              <div className="dsib-usernamePassword__usernameValue" id="txtUsername">
                {contractor.email}
              </div>
            </div>

            <div className="dsib-usernamePassword__fields">
              <div className="dsib-usernamePassword__field">
                <Input
                  label="Password"
                  type="password"
                  value={password}
                  status={this.getPasswordStatus()}
                  onBlur={this.setPasswordBlur}
                  onChange={value => this.handleTextChange(value, 'password')}
                  inputProps={{
                    id: 'txtPassword',
                    name: 'txtPassword',
                    autoComplete: 'new-password'
                  }}
                />
              </div>

              <div className="dsib-usernamePassword__field">
                <Input
                  label="Confirm password"
                  type="password"
                  value={confirmPassword}
                  status={this.getConfirmPasswordStatus()}
                  onBlur={this.setConfirmPasswordBlur}
                  onChange={value => this.handleTextChange(value, 'confirmPassword')}
                  inputProps={{
                    id: 'txtConfirmPassword',
                    name: 'txtConfirmPassword',
                    autoComplete: 'new-password'
                  }}
                />
              </div>
            </div>

            {employerErrorMessage ? (
              <div className="dsib-usernamePassword__employerError">
                {employerErrorMessage}
              </div>
            ) : null}

            <div className="dsib-usernamePassword__actions">
              <Button
                type="button"
                onClick={this.handleSubmit}
                disabled={!this.checkAllFieldsValid()}
                isFullWidth
                variant="primary"
              >
                Register
              </Button>

              {submitErrorMessage ? (
                <div className="dsib-usernamePassword__submitError">
                  <Alert status="error" isOpen message={submitErrorMessage} />
                </div>
              ) : null}
            </div>
          </div>
        </Container>
        {loading
              && <LoadingOverlay hasBackground text="Registering your account..." />
            }
      </div>
    )
  }
}

UsernamePassword.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  setRememberMe: PropTypes.func.isRequired,
  rememberMe: PropTypes.bool,
  contractor: PropTypes.shape({
    forename: PropTypes.string,
    surname: PropTypes.string,
    jobRoleId: PropTypes.number,
    telephoneNumber: PropTypes.string,
    employerId: PropTypes.number,
    carRegistration: PropTypes.string
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
}

UsernamePassword.defaultProps = {
  rememberMe: false,

}

export default UsernamePassword
